import React from 'react'
import './Career.css'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import WelcomeComponent from '../AboutUs/WelcomeComponent/WelcomeComponent'
import CurrentOpenings from './CurrentOpenings/CurrentOpenings'

const Career = () => {

    const welcomeText = "Join Our Team & Build the Future"
    const para1 = "Passionate about web innovation? We’re looking for creative minds to build the future with us. Explore exciting career opportunities and grow with a dynamic team. Let’s create something amazing together! Passionate about web innovation? We’re looking for creative minds to build the future with us. Explore exciting career opportunities and grow with a dynamic team. Let’s create something amazing together!"

    return (
        <section className='Career AboutUs'>
            <BannerComponent img="\assets\Images\Career\banner.png" title="Career" />

            <div className='container'>
                <div className='below_banner_section'>
                    <WelcomeComponent title_text={welcomeText} para1={para1} />

                    <CurrentOpenings />
                </div>
            </div>

        </section>
    )
}

export default Career
